import { RootState, setBundlePagesBlankState } from '@/store';
import { api } from '../core';
import { refreshBundleSectionsWithCurrentFilters } from './getBundleSections';

export interface FlagPageNode {
  pageId: string;
  confirmedBlank: boolean;
  confirmedBreach: boolean;
  detectedBlank: boolean;
  detectedBreach: boolean;
}

type BundleMarkBlankResponse = FlagPageNode[];

export interface BundleMarkBlankRequest {
  bundleId: string;
  bundlePageIds: string[];
}

const bundleMarkBlankApi = api.injectEndpoints({
  endpoints: (builder) => ({
    bundleMarkBlank: builder.mutation<BundleMarkBlankResponse, BundleMarkBlankRequest>({
      query: ({ bundleId, bundlePageIds }: BundleMarkBlankRequest) => ({
        url: 'bundle/mark/blank',
        method: 'POST',
        body: { bundleId, bundlePageIds },
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          // The response carries the new blank state, so /bundle does not need refetching.
          dispatch(
            setBundlePagesBlankState({
              pages: data.map(({ pageId, confirmedBlank }) => ({ pageId, isBlank: confirmedBlank })),
            }),
          );
          // Sections still refetch because the blank filters decide which pages are listed.
          refreshBundleSectionsWithCurrentFilters(dispatch, getState() as RootState);
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in bundleMarkBlank in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useBundleMarkBlankMutation } = bundleMarkBlankApi;
